import { render, staticRenderFns } from "./moneymanage.vue?vue&type=template&id=2c38c13b"
import script from "./moneymanage.vue?vue&type=script&lang=js"
export * from "./moneymanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports